import { createSlice } from "@reduxjs/toolkit";

const trackingDialogSlice = createSlice({
  name: "trackingDialog",
  initialState: {
    open: false,
    options: {},
  },
  reducers: {
    openTrackingDialog: (state, action) => {
      state.open = true;
      state.options = action.payload;
    },
    closeTrackingDialog: (state) => {
      state.open = false;
      state.options = {}
    },
  },
});

export const selectStateTrackingDialog = (state: any) =>
  state.trackingApp.trackingDialog;

export const { openTrackingDialog, closeTrackingDialog } = trackingDialogSlice.actions;

export default trackingDialogSlice.reducer;
